import React, { useState } from 'react';
import TagManager from 'react-gtm-module';
import { AdminModeSwitch } from '@components/common/AdminModeSwitch';
import { UserDetails } from '@components/common/UserDetails';
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags';
import { useDashboardPermissions } from '@components/utils/DashboardPermissions';
import { FeatureFlagDecorator } from '@components/utils/FeatureFlagDecorator';
import { useAppearance } from '@fourthwall/appearance';
import { useAuth } from '@fourthwall/auth';
import { Avatar, Dropdown, Icon } from '@fourthwall/components';
import { ArrowShortLeftIcon, ArrowShortRightIcon, TickIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { ShopSwitch } from '../ShopSwitch';
import * as S from './styled';
export const ProfileDropdown = ({ variant = 'avatar', label, avatarSize = 'medium', testid, backgroundColor, connectedShops, partnerDashboardUrl, user, }) => {
    const { logout } = useAuth();
    const { hasPermission } = useDashboardPermissions();
    const { appearance, setAppearance } = useAppearance();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { currentShop } = useCurrentShop();
    const [isOpen, setIsOpen] = useState(false);
    const [isAppearanceDropdownOpen, setIsAppearanceDropdownOpen] = useState(false);
    const handleSetAppearance = (newAppearance) => {
        setAppearance(newAppearance);
        TagManager.dataLayer({
            dataLayer: {
                event: 'appearance_change',
                appearance_from: appearance,
                appearance_to: newAppearance,
                shopId: currentShop?.id || '',
            },
        });
    };
    const component = {
        'menu-item': (React.createElement(S.MenuItem, { onClick: () => setIsOpen((state) => !state) },
            React.createElement(S.MenuItemContent, null,
                React.createElement(S.MenuItemAvatarContainer, null,
                    React.createElement(S.AvatarWrapper, null,
                        React.createElement(Avatar, { name: user?.name || '', size: avatarSize }),
                        label && (React.createElement(S.AvatarLabel, { borderColor: backgroundColor, size: avatarSize }, label)))),
                React.createElement(S.MenuItemName, null, user?.name || '')),
            React.createElement(Icon, { component: ArrowShortRightIcon, height: 12 }))),
        avatar: (React.createElement(S.AvatarWrapper, null,
            React.createElement(Avatar, { name: user?.name || '', size: avatarSize, hoverable: true, active: isOpen, onClick: () => setIsOpen((state) => !state) }),
            label && (React.createElement(S.AvatarLabel, { borderColor: backgroundColor, size: avatarSize }, label)))),
    }[variant];
    const getContent = () => {
        if (isAppearanceDropdownOpen) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Dropdown.Item, { label: "Back", leftIcon: ArrowShortLeftIcon, onClick: () => setIsAppearanceDropdownOpen(false) }),
                React.createElement("div", { style: { width: 300 } }),
                React.createElement(Dropdown.Divider, null),
                React.createElement(Dropdown.Heading, { label: "Appearance" }),
                React.createElement(Dropdown.Item, { label: "Use device mode", rightIcon: appearance === 'light dark' ? TickIcon : undefined, onClick: () => handleSetAppearance('light dark') }),
                React.createElement(Dropdown.Item, { label: "Dark mode", rightIcon: appearance === 'dark' ? TickIcon : undefined, onClick: () => handleSetAppearance('dark') }),
                React.createElement(Dropdown.Item, { label: "Light mode", rightIcon: appearance === 'light' ? TickIcon : undefined, onClick: () => handleSetAppearance('light') })));
        }
        return (React.createElement(React.Fragment, null,
            user && React.createElement(UserDetails, { name: user.name || 'My Account', email: user.email }),
            React.createElement(S.AdminModeSwitchWrapper, null,
                React.createElement(AdminModeSwitch, null)),
            React.createElement(Dropdown.Divider, null),
            React.createElement(ShopSwitch, { connectedShops: connectedShops }),
            dashboardFeatureFlags.appearanceMode?.enabled && (React.createElement(Dropdown.Item, { label: "Appearance", rightIcon: ArrowShortRightIcon, onClick: () => setIsAppearanceDropdownOpen(true) })),
            dashboardFeatureFlags.account?.enabled && hasPermission('accountSettings') && (React.createElement(Dropdown.Item, { label: React.createElement(FeatureFlagDecorator, { ...dashboardFeatureFlags.account, display: "inline", spacing: "small" }, "Account settings"), to: routing.account.self, onClick: () => setIsOpen(false) })),
            partnerDashboardUrl && (React.createElement(Dropdown.Item, { label: "Partner dashboard", href: partnerDashboardUrl, target: "_blank" })),
            React.createElement(Dropdown.Item, { label: "Help center", href: routing.external.helpCenter.self, target: "_blank", analytics: "helpCenter" }),
            React.createElement(Dropdown.Item, { label: "Logout", testid: "logout", onClick: () => logout?.() })));
    };
    return (React.createElement(Dropdown, { content: getContent(), isOpen: isOpen, position: "bottom-end", maxWidth: 300, testid: testid, onClose: () => {
            setIsOpen(false);
            setIsAppearanceDropdownOpen(false);
        } }, component));
};
